import GroupOrder from "@/views/admin/grouporder/GroupOrder";

export default {
  path: "products/group-orders",
  name: "group-orders",
  component: GroupOrder,
  props: true,
  meta: {
    requiresAuth: true
  }
};
